import React, { useEffect, useState } from 'react';
import {
    TextField,
    Button,
    Checkbox,
    Box,
    Typography,
    Paper,
    FormControlLabel,
    InputAdornment
} from '@mui/material';
import { ChevronLeft, User } from 'react-feather';
import { Link, useLocation } from 'react-router-dom';
import Grid from '@mui/material/Grid2';
import Toastmessage from '../../components/Toast';
import { logout } from '../../features/auth/AuthSlice';
import { authApi } from '../../api/api';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { debounce } from 'lodash';
import { useCallback } from 'react';

export default function CreateMember() {
    const [assets, setAssets] = useState({});
    const [errors, setErrors] = useState({});
    const [categories, setCategories] = useState([]);
    const [assetData, setAssetData] = useState(null);
     const [isLoading, setIsloading] = useState(false);

    const [userData, setUserData] = useState({
        name: '',
        gender: '',
        dob: '',
        dod: '',
        relationship: '',
    });

    const token = useSelector((state) => state.auth.token);
    const userID = useSelector((state) => state.auth.id);

    const location = useLocation();
    const { member } = location.state || {};
    const { estate_id } = location.state || {};


    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (member && token && userID) {
            fetchAssetDetails(member);
        }
    }, [member, token, userID]);

    useEffect(() => {
        if (categories.length > 0 && assetData) {
            const transform = transformedData(assetData);
            setAssets(transform);
        }
    }, [assetData]);

    const fetchAssetDetails = async (member) => {
        const input_token = member + 'ASSIGN_ESTATE';
        const apiUrl = 'assets_with_total_value';
        const dataInput = {
            member_id: member,
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);
            if (data && data.success) {
                const categoriesWithIcheck = (data?.data?.estate_asset_value?.assets_value || []).map(category => ({
                    ...category,
                    icheck: category.iCheck
                }));
                setCategories(categoriesWithIcheck);
                setUserData({
                    ...userData,
                    name: data?.data?.family_member_detail?.name,
                    gender: data?.data?.family_member_detail?.gender,
                    dob: data?.data?.family_member_detail?.bdate,
                    dod: data?.data?.family_member_detail?.ddate || "-",
                    relationship: data?.data?.family_member_detail?.relationship,
                });
                const assetData = JSON.parse(data?.data?.saved_estate_asset_value?.property_details || '{}');
                setAssetData(assetData);

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    const categoryNames = Array.isArray(categories) ? categories.reduce((acc, category) => {
        acc[category.asset_type_id] = category.asset_type_name;
        return acc;
    }, {}) : {};

    const transformedData = (data) => {
        return Object.keys(data).reduce((acc, key) => {
            const category = categoryNames[key];
            if (category) {
                acc[key] = data[key]?.map((item) => ({
                    id: Date.now() + Math.random(),
                    category: category,
                    assetId: key,
                    icheck: categories.find(cat => cat.asset_type_id === parseInt(key))?.iCheck || false,
                    data: {
                        ...item,
                        isChecked: item.isChecked
                    },
                }));
            }
            return acc;
        }, {});
    };

    const calculatedApi = async (category, value, index, total, id, percentage) => {
        const input_token = parseInt(estate_id) + 'CALCULATE_AVAILABLE_VALUE';
        const apiUrl = 'calculate_available_value';
        const dataInput = {
            login_user_id: userID,
            estate_id: parseInt(estate_id),
            family_member_id: member,
            category_id: parseInt(category),
            property_id: parseInt(index),
            calculated_value: parseInt(value),
            calculated_percentage: parseFloat(percentage),
            total_value: parseInt(total),
            id: parseInt(id)
        };
        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);
            if (data && data.success) {

                setAssets((prevAssets) => ({
                    ...prevAssets,
                    [data.category_id]: prevAssets[data.category_id]?.map((item) => {
                        if (item.id === id) {
                            const newValue = parseFloat(value) || 0;
                            const totalValue = parseFloat(item.data.value);
                        
                            const percentage = ((newValue / totalValue) * 100).toFixed(2);
                            return {
                                ...item,
                                data: {
                                    ...item.data,
                                    available_value: parseFloat(data.available_value?.toFixed(2)) ?? 0, // Set 0 when undefined or null
                                    available_percentage: parseFloat(data.available_percentage?.toFixed(2)) ?? 0, // Set 0 when undefined or null
                                },
                            };
                        }
                        return item;
                    }),
                }));
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    // const debouncedHandleValueChange = useCallback(
    //     debounce((categoryKey, itemId, value, index, originalValue) => {
    //         handleValueChange(categoryKey, itemId, value, index, originalValue);
    //     }, 300),
    //     []
    // );

    const debouncedApiCall = useCallback(
        debounce((category, value, index, total, id, percentage) => {
            calculatedApi(category, value, index, total, id, percentage);
        }, 500),
        []
    );

    const handleValueChange = (category, id, value, index, total, availableValue) => {

        setAssets((prevAssets) => ({
            ...prevAssets,
            [category]: prevAssets[category]?.map((item) => {
                if (item.id === id && item.data.isChecked) {
                    const newValue = parseFloat(value) || 0;
                    const totalValue = parseFloat(item.data.value);

                    // Handle empty or null value
                    if (value === "" || value === null) {
                        debouncedApiCall(category, value, index, total, id, null);
                        setErrors((prevErrors) => ({
                            ...prevErrors,
                            [id]: { ...prevErrors[id], value: "" },
                        }));
                        return {
                            ...item,
                            data: {
                                ...item.data,
                                calculatedValue: null,
                                calculatedPercentage: '',
                            },
                        };
                    }

                    if (newValue > availableValue) {
                        setErrors((prevErrors) => ({
                            ...prevErrors,
                            [id]: { ...prevErrors[id], value: `Value exceeds ${availableValue} balance.` },
                        }));
                        return item;
                    } else {
                        setErrors((prevErrors) => ({
                            ...prevErrors,
                            [id]: { ...prevErrors[id], value: "" },
                        }));
                    }

                    const percentage = ((newValue / totalValue) * 100).toFixed(2);
                    debouncedApiCall(category, value, index, total, id, null);
                    return {
                        ...item,
                        data: {
                            ...item.data,
                            calculatedValue: parseFloat(newValue),
                            calculatedPercentage: parseFloat(percentage),
                        },
                    };

                }
                return item;
            }),
        }));

    };
    const handlePercentageChange = (category, id, value, index, total, availableValue) => {
        setAssets((prevAssets) => ({
            ...prevAssets,
            [category]: prevAssets[category]?.map((item) => {
                if (item.id === id && item.data.isChecked) {
                    // Handle empty or invalid input
                    if (!value || isNaN(parseFloat(value))) {
                        debouncedApiCall(category, null, index, total, id,value);
                        setErrors((prevErrors) => ({
                            ...prevErrors,
                            [id]: { ...prevErrors[id], percentage: "" },
                        }));

                        return {
                            ...item,
                            data: {
                                ...item.data,
                                calculatedPercentage: null,
                                calculatedValue: '',
                            },
                        };
                    }

                    const newPercentage = parseFloat(value);

                    if (newPercentage > (availableValue / total) * 100) {
                        setErrors((prevErrors) => ({
                            ...prevErrors,
                            [id]: { ...prevErrors[id], percentage: `Percentage exceeds ${(availableValue / total) * 100}%.` },
                        }));
                        return item;
                    } else {
                        setErrors((prevErrors) => ({
                            ...prevErrors,
                            [id]: { ...prevErrors[id], percentage: "" },
                        }));
                    }

                    const totalValue = parseFloat(item.data.value);
                    const newValue = ((newPercentage / 100) * totalValue).toFixed(2);
                    debouncedApiCall(category, null, index, total, id, value);
                    return {
                        ...item,
                        data: {
                            ...item.data,
                            calculatedPercentage: parseFloat(newPercentage),
                            calculatedValue: parseFloat(newValue),
                        },
                    };
                }
                return item;
            }),
        }));
    };


    // const handleValueChange = (category, id, value) => {
    //     setAssets((prevAssets) => ({
    //         ...prevAssets,
    //         [category]: prevAssets[category]?.map((item) => {
    //             if (item.id === id && item.data.isChecked) {
    //                 const newValue = parseFloat(value) || 0;
    //                 const totalValue = parseFloat(item.data.value);

    //                 // Handle empty or null value
    //                 if (value === "" || value === null) {
    //                     setErrors((prevErrors) => ({
    //                         ...prevErrors,
    //                         [id]: { ...prevErrors[id], value: "" },
    //                     }));
    //                     return {
    //                         ...item,
    //                         data: {
    //                             ...item.data,
    //                             calculatedValue: null,
    //                             calculatedPercentage: '',
    //                         },
    //                     };
    //                 }

    //                 if (newValue > totalValue) {
    //                     setErrors((prevErrors) => ({
    //                         ...prevErrors,
    //                         [id]: { ...prevErrors[id], value: "Value exceeds available balance." },
    //                     }));
    //                     return item;
    //                 } else {
    //                     setErrors((prevErrors) => ({
    //                         ...prevErrors,
    //                         [id]: { ...prevErrors[id], value: "" },
    //                     }));
    //                 }

    //                 const percentage = ((newValue / totalValue) * 100).toFixed(2);
    //                 return {
    //                     ...item,
    //                     data: {
    //                         ...item.data,
    //                         calculatedValue: parseFloat(newValue),
    //                         calculatedPercentage: parseFloat(percentage),
    //                     },
    //                 };
    //             }
    //             return item;
    //         }),
    //     }));
    // };


    // const handlePercentageChange = (category, id, value) => {
    //     setAssets((prevAssets) => ({
    //         ...prevAssets,
    //         [category]: prevAssets[category]?.map((item) => {
    //             if (item.id === id && item.data.isChecked) {
    //                 // Handle empty or invalid input
    //                 if (!value || isNaN(parseFloat(value))) {
    //                     setErrors((prevErrors) => ({
    //                         ...prevErrors,
    //                         [id]: { ...prevErrors[id], percentage: "" },
    //                     }));

    //                     return {
    //                         ...item,
    //                         data: {
    //                             ...item.data,
    //                             calculatedPercentage: null,
    //                             calculatedValue: '',
    //                         },
    //                     };
    //                 }

    //                 const newPercentage = parseFloat(value);

    //                 if (newPercentage > 100) {
    //                     setErrors((prevErrors) => ({
    //                         ...prevErrors,
    //                         [id]: { ...prevErrors[id], percentage: "Percentage exceeds 100%." },
    //                     }));
    //                     return item;
    //                 } else {
    //                     setErrors((prevErrors) => ({
    //                         ...prevErrors,
    //                         [id]: { ...prevErrors[id], percentage: "" },
    //                     }));
    //                 }

    //                 const totalValue = parseFloat(item.data.value);
    //                 const newValue = ((newPercentage / 100) * totalValue).toFixed(2);
    //                 return {
    //                     ...item,
    //                     data: {
    //                         ...item.data,
    //                         calculatedPercentage: parseFloat(newPercentage),
    //                         calculatedValue: parseFloat(newValue),
    //                     },
    //                 };
    //             }
    //             return item;
    //         }),
    //     }));
    // };

    const handleCheckboxChange = (category, id) => {
        setAssets((prevAssets) => ({
            ...prevAssets,
            [category]: prevAssets[category]?.map((item) => {
                if (item.id === id) {
                    const isChecked = !item.data.isChecked;
                    if (!isChecked) {
                        setErrors((prevErrors) => ({
                            ...prevErrors,
                            [id]: { value: "", percentage: "" }
                        }));
                    }
                    return {
                        ...item,
                        data: {
                            ...item.data,
                            isChecked,
                        },
                    };
                }
                return item;
            })
        }));
    };


    const handleSubmit = () => {
        let hasErrors = false;
        const newErrors = {};

        Object.keys(assets).forEach((category) => {
            assets[category]?.forEach((item) => {
                if (item.data.isChecked && item.icheck) {
                    const { calculatedValue, calculatedPercentage, value } = item.data;
                    const totalValue = parseFloat(value);

                    if (calculatedValue <= 0) {
                        newErrors[item.id] = { ...newErrors[item.id], value: "Value must be greater than zero." };
                        hasErrors = true;
                    } else if (calculatedValue > totalValue) {
                        newErrors[item.id] = { ...newErrors[item.id], value: "Entered value exceeds available balance." };
                        hasErrors = true;
                    }

                    if (calculatedPercentage <= 0) {
                        newErrors[item.id] = { ...newErrors[item.id], percentage: "Percentage must be greater than zero." };
                        hasErrors = true;
                    } else if (calculatedPercentage > 100) {
                        newErrors[item.id] = { ...newErrors[item.id], percentage: "Entered percentage exceeds 100%." };
                        hasErrors = true;
                    }
                }
            });
        });

        setErrors(newErrors);

        if (hasErrors) {
            Toastmessage('Please correct the errors before submitting.', false);
            return;
        }

        const payload = Object.keys(assets).reduce((acc, category) => {
            const validItems = assets[category]?.map(item => ({
                ...item.data,
                category: category,
                calculatedValue: item.icheck && item.data.isChecked ? item.data.calculatedValue : null,
                calculatedPercentage: item.icheck && item.data.isChecked ? item.data.calculatedPercentage : null
            }));

            if (validItems && validItems.length > 0) {
                acc[category] = validItems;
            }
            return acc;
        }, {});


        if (Object.keys(payload).length === 0) {
            Toastmessage('Please select and fill in valid values for at least one asset.', false);
            return;
        }
        const categoriesWithIcheck = categories?.map(category => ({
            asset_type_id: category.asset_type_id,
            asset_type_name: category.asset_type_name,
            icheck: category.icheck
        }));

        const addEstateApi = async () => {
            setIsloading(true)
            const input_token = member + 'SAVE_ASSETS';
            const apiUrl = 'save_asset_distribution';

            const datainput = {
                auth_token: token,
                login_user_id: userID,
                family_member_id: member,
                property_details: payload,
                asset_type: categoriesWithIcheck
            };
            try {
                const data = await authApi(input_token, datainput, apiUrl, token, true);

                if (data && data.success) {
                    await Toastmessage(data.message, true);
                    setTimeout(() => navigate(-1), 2000);
                } else if (data && data.message === 'Token has expired') {
                    setIsloading(false)
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else if (data === undefined) {
                    setIsloading(false)
                    await Toastmessage('No response from server', false);
                } else {
                    setIsloading(false)
                    await Toastmessage(data?.message || 'An error occurred', false);
                }
            } catch (error) {
                setIsloading(false)
                console.error("Error fetching data:", error);
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else {
                    await Toastmessage('Something went wrong', false);
                }
            }
        };

        addEstateApi();
    };

    const AssetCheckboxChange = (assetId) => {
        setCategories((prevCategories) =>
            prevCategories.map((category) => {
                if (category.asset_type_id === assetId) {
                    return { ...category, icheck: !category.icheck };
                }
                return category;
            })
        );

        setAssets((prevAssets) => {
            if (prevAssets[assetId]) {
                return {
                    ...prevAssets,
                    [assetId]: prevAssets[assetId].map((item) => ({
                        ...item,
                        icheck: !item.icheck,
                    })),
                };
            }
            return prevAssets;
        });
    };


    return (
        <Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                <Box display="flex" alignItems="center">
                    <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={12} color="var(--text-color)">
                        Add Assets to Family Member
                    </Typography>
                </Box>

                <Button
                    variant="outlined"
                    component={Link}
                    to="/familytree"
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Back to Members list
                </Button>
            </Box>

            <Box className="card-box" sx={{ p: { xs: 2, sm: 2, md: 3 }, m: { xs: 1, sm: 2, md: 3 }, border: '1px solid var(--border-color)', borderRadius: '8px' }}>
                <Box className="sub-header" display={"block"}>
                    <Grid container justifyContent={'space-between'} spacing={4} sx={{ my: 1 }}>
                        <Grid item md={2}>
                            <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                                Name: {userData.name}
                            </Typography>
                        </Grid>
                        <Grid item md={2}>
                            <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                                Gender: {userData.gender}
                            </Typography>
                        </Grid>
                        <Grid item md={2}>
                            <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                                DOB: {userData.dob}
                            </Typography>
                        </Grid>
                        <Grid item md={2}>
                            <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                                DOD: {userData.dod}
                            </Typography>
                        </Grid>
                        <Grid item md={2}>
                            <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                                Relationship: {userData.relationship}
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>

                <Box mb={1}>
                    <Typography variant="subtitle1" gutterBottom>
                        Total Property Value
                    </Typography>
                    <Box display="flex" flexWrap="wrap" gap={10}>
                        {categories.map((item, index) => (
                            <Box
                                key={index}
                                sx={{
                                    textAlign: 'left',
                                    minWidth: '100px',
                                }}
                            >
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                    {item.asset_type_name}
                                </Typography>
                                <Typography variant="body2" sx={{ fontSize: '17px' }}>{new Intl.NumberFormat('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                }).format(item.total_asset_value)}</Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: item.total_assets_percent === 100 ? 'green' : 'black',
                                    }}
                                >
                                    {item.total_assets_percent} %
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>

                <Box mb={1}>
                    <Typography variant="subtitle1" gutterBottom>
                        Asset Type
                    </Typography>
                    <Box display="flex" flexWrap="wrap" gap={3}>
                        {categories.map((asset) => (
                            <FormControlLabel
                                key={asset.asset_type_id}
                                control={
                                    <Checkbox
                                        checked={asset.icheck}
                                        onChange={() => AssetCheckboxChange(asset.asset_type_id)}
                                        sx={{
                                            transform: "scale(0.7)",
                                            borderRadius: "8px",
                                            padding: "2px",
                                            "&.Mui-checked": {
                                                color: "#3570FF",
                                            },
                                        }}
                                    />
                                }
                                label={asset.asset_type_name}
                            />
                        ))}
                    </Box>
                </Box>
                <Box>
                    {Object.keys(assets).map((categoryKey) => (
                        <Paper key={categoryKey} sx={{ padding: 2, marginY: 2, backgroundColor: 'var(--sub-header-bg)', border: "1px solid #E1E1E1", boxShadow: 'none', display: assets[categoryKey]?.[0]?.icheck ? 'block' : 'none' }}>
                            <Typography variant="h6" sx={{ marginBottom: 1, fontSize: '15px' }}>
                                {assets[categoryKey]?.[0]?.category}
                            </Typography>
                            {assets[categoryKey]?.map((item, index) => (
                                <Box
                                    key={item.id}
                                    display="flex"
                                    alignItems="center"
                                    gap={3}
                                    justifyContent="space-between"
                                    sx={{ marginBottom: 2 }}
                                >
                                    <Box sx={{ flex: '.2' }}>
                                        <Checkbox
                                            checked={item.data.isChecked}
                                            onChange={() => handleCheckboxChange(categoryKey, item.id)}
                                            disabled={parseFloat(item.data.available_value) === 0}
                                        />
                                    </Box>
                                    <Box sx={{ flex: '1.8' }}>
                                        <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}>Property</Typography>
                                        <Typography>{item.data.propertyAddress || item.data.yearMakeModel || item.data.institutionName || item.data.description}</Typography>
                                    </Box>
                                    <Box sx={{ flex: '1.8' }}>
                                        <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}>Property Total Value</Typography>
                                        {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat(item.data.value))}
                                    </Box>
                                    <Box sx={{ flex: '1.8' }}>
                                        <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}>
                                            Available $ Value
                                        </Typography>
                                        <Typography>
                                            {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
                                                parseFloat(item.data.available_value)
                                            )}
                                            {' '}
                                            /
                                            {' '}
                                            <span style={{ color: 'green' }}>
                                                {(item.data.available_percentage)} %
                                            </span>
                                        </Typography>
                                    </Box>
                                    <Box sx={{ flex: '3' }}>
                                        <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}>$ Value to the {userData.name}</Typography>
                                        <TextField
                                            value={item.data.calculatedValue}
                                            onChange={(e) => handleValueChange(categoryKey, item.id, e.target.value, index + 1, item.data.value, item.data.balance_value)}
                                            placeholder="Enter the value"
                                            fullWidth
                                            sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                            helperText={errors[item.id]?.value}
                                            error={!!errors[item.id]?.value}
                                            disabled={!(item.data.available_value && item.data.isChecked)}
                                            slotProps={{
                                                input: {
                                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                },
                                            }}
                                        />
                                    </Box>
                                    <Box sx={{ flex: '3' }}>
                                        <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}>Percentage to the {userData.name}</Typography>
                                        <TextField
                                            value={item.data.calculatedPercentage}
                                            onChange={(e) => handlePercentageChange(categoryKey, item.id, e.target.value, index + 1, item.data.value, item.data.balance_value)}
                                            placeholder="Enter the Percentage"
                                            fullWidth
                                            sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                            helperText={errors[item.id]?.percentage}
                                            error={!!errors[item.id]?.percentage}
                                            disabled={!(item.data.available_value && item.data.isChecked)}
                                            slotProps={{
                                                input: {
                                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                },
                                            }}
                                        />
                                    </Box>
                                </Box>
                            ))}
                        </Paper>
                    ))}
                    <Box sx={{ textAlign: "center", marginTop: 4 }}>
                        <Button variant="contained" 
                         className='btn-theme-button'
                        onClick={handleSubmit} disabled={isLoading}>
                            Update Assets to Members
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
